export const AdmissionDecisionVI = {
    "decisionAdmission": {
        "breadCrumb": {
            "add": "Tạo mới quyết định tiếp nhận",
            "update": "Cập nhật quyết định tiếp nhận",
            "detail": "Chi tiết quyết định tiếp nhận"
        },
        "placeholder": {
            "no": "QD001",
            "date": "dd/mm/yyyy",
            "positionDecision": "Nhập cấp ra quyết định",
            "employee": "Nhập nhân viên tiếp nhận",
            "reason": "Nhập lý do",
            "lineManager": "Nhập người quản lý trực tiếp",
            "oldDepartment": "Phòng ban cũ",
            "oldPosition": "Vị trí cũ",
            "oldJobTitle": "Chức vụ cũ",
            "newDepartment": "Phòng ban tiếp nhận",
            "newPosition": "Vị trí tiếp nhận",
            "newJobTitle": "Chức vụ tiếp nhận",
            "description": "Nhập mô tả",
            "reasonReward": "Choose reason",
            "approve": "Choose approve"
        },
        "label": {
            "no": "Số quyết định",
            "dateDecision": "Ngày quyết định",
            "dateEffective": "Ngày hiệu lực",
            "employee": "Nhân viên",
            "reason": "Lý do tiếp nhận",
            "oldDepartment": "Phòng ban cũ",
            "oldPosition": "Vị trí cũ",
            "oldJobTitle": "Chức vụ cũ",
            "newDepartment": "Phòng ban tiếp nhận",
            "newPosition": "Vị trí tiếp nhận",
            "newJobTitle": "Chức vụ tiếp nhận",
            "positionDecision": "Cấp ra quyết định",
            "status": "Trạng thái",
            "description": "Mô tả",
            "lineManager": "Người quản lý trực tiếp"
        },
        "message" : {
            "department": "Vui lòng chọn phòng ban tiếp nhận",
            "jobPosition" : "Vui lòng chọn vị trí tiếp nhận",
            "jobTitle" : "Vui lòng chọn chức vụ tiếp nhận"
        }
    }
}